<template lang="pug">
  el-dialog(
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    class="custom-dialog-logout"
    top="5vh"
    :close-on-click-modal="false"
  )
    div(slot="title") Sair da aplicação
    .conteudo
      div Deseja realmente deslogar da aplicação ?
      .btns
        el-button(type="danger" plain @click="sair") Sair
        el-button(type="text" @click="dialogVisible = false") Cancelar
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LoginGoogle from '../LoginGoogle.vue'

export default {
name: 'ModalLogout',

components: {
  LoginGoogle
},

data(){
  return{
    currentDialogWidth: this.calculateDialogWidth(),
  }
},

mounted() {
  window.addEventListener('resize', this.handleResize);
},
beforeDestroy() {
  window.removeEventListener('resize', this.handleResize);
},

computed: {
  ...mapGetters({
    getLogout: 'modais/getLogout'
  }),

  dialogWidth() {
    return this.currentDialogWidth;
  },

  dialogVisible: {
    get(){
      return this.getLogout
    },
    set(newValue){
      this.setLogout(newValue)
    }
  },
},

  methods: {
    ...mapMutations({
      setLoading: 'globais/setLoading',
      setLogout: 'modais/setLogout',
    }),
    calculateDialogWidth() {
      return window.innerWidth < 576 ? '90%' : '490px'
    },
    handleResize() {
      this.currentDialogWidth = this.calculateDialogWidth()
    },
    sair(){
      this.setLogout(false)
      localStorage.removeItem('_linkdrive')
      localStorage.removeItem('user')
      this.$message({
        message: 'Sua sessão foi encerrada com sucesso!',
        type: 'success'
      })
      setTimeout(() => {
        location.reload()
      }, 1500)
    }
  },
}
</script>

<style lang="scss">
.custom-dialog-logout {
background: rgba(0, 0, 0, .6);

  .el-dialog {
    border-radius: 10px;

    .el-dialog__header{
      padding: 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn{
        top: 19px;

        i{
          font-size: 30px;
        }
      }
    }

    .el-dialog__body{
      padding: 20px;

      .conteudo{
        & > div{
          font-size: 16px;
          text-align: center;
          margin: 30px 0;
        }
      }
    }

    .el-dialog__footer {
     display: none;
    }
  }
}
</style>